import React from 'react'
import * as Styled from './RedditCard.styled'
import defaultUserProfile from './images/default-user.png'
import logo from './images/reddit-logo.webp'
import up from './images/up.svg'
import down from './images/down.svg'
import comment from './images/comment.svg'

interface RedditPost {
  score: number
  ups: number
  commentCount: number
  createdAt: string
  userCommentKarma: number
  mediaUrl: string
  userLinkKarma: number
  isUserVerified: boolean
  url: string
  text: string
  userName: string
  userProfilePictureUrl: string
  analysis: string
}

interface RedditCardProps {
  reddit: RedditPost
  index: number
  updateShowFullTextList: (index: number, showFullText: boolean) => void
  showFullTextList: boolean[]
}

const RedditCard: React.FC<RedditCardProps> = ({
  reddit,
  index,
  updateShowFullTextList,
  showFullTextList,
}) => {
  const timeAgo = (input: Date | string | number) => {
    const date = input instanceof Date ? input : new Date(input)
    const formatter = new Intl.RelativeTimeFormat('tr')
    const ranges = [
      ['years', 3600 * 24 * 365],
      ['months', 3600 * 24 * 30],
      ['weeks', 3600 * 24 * 7],
      ['days', 3600 * 24],
      ['hours', 3600],
      ['minutes', 60],
      ['seconds', 1],
    ] as const
    const secondsElapsed = (date.getTime() - Date.now()) / 1000

    for (const [rangeType, rangeVal] of ranges) {
      if (rangeVal < Math.abs(secondsElapsed)) {
        const delta = secondsElapsed / rangeVal
        return formatter.format(Math.round(delta), rangeType)
      }
    }
  }

  function hasErrorImage(e: React.SyntheticEvent) {
    e.currentTarget.setAttribute('src', logo)
  }

  function hasErrorImageProfil(e: React.SyntheticEvent) {
    e.currentTarget.setAttribute('src', defaultUserProfile)
  }

  const textLength = reddit?.text && reddit.mediaUrl
    ? reddit?.text?.length >= 400
    : reddit?.text?.length >= 200

  const showFullText = showFullTextList[index] || false

  return (
    <Styled.RedditCardWrapper>
      <div className="post">
        <div className="post-header">
          <div className="post-header-info">
            <div className="post-header-profile">
              <div className="post-header-profile-image">
                <img
                  src={reddit?.userProfilePictureUrl || defaultUserProfile}
                  onError={hasErrorImageProfil}
                  alt=""
                />
              </div>
              <div className="post-header-profile-name">
                <span>r/{reddit?.userName}</span>
              </div>
            </div>
            <div className="post-header-dot"></div>
            <div className="post-header-time">
              <span>{timeAgo(reddit?.createdAt)}</span>
            </div>
          </div>
          <div className="post-header-logo">
            <img src={logo} alt="Reddit Logo" />
          </div>
        </div>
        <div className="post-body">
          <div className="post-body-text">
            <div>
              {textLength && !showFullText
                ? reddit?.text?.slice(0, 400) + '...'
                : reddit?.text}
            </div>
            {textLength && (
              <button onClick={() => updateShowFullTextList(index, !showFullText)}>
                {showFullText ? 'Daha Az' : 'Daha Fazla'}
              </button>
            )}
          </div>
        </div>
        <div className="post-footer">
          <div className="post-footer-info">
            <div className="post-footer-info-like">
              <img src={up} alt="Up" />
              <span>{reddit?.score}</span>
              <img src={down} alt="Down" />
            </div>

            <div className="post-footer-info-comments">
              <img src={comment} alt="Comment" />
              <span>{reddit?.commentCount} </span>
            </div>
          </div>
          <div className="post-footer-url reddit-orange">
            <a href={reddit?.url} target="_blank" rel="noreferrer">
              Post'u görüntüle
            </a>
          </div>
        </div>
      </div>
    </Styled.RedditCardWrapper>
  )
}

export default RedditCard 